import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-33ff2aeb.js';
import Group from './Group.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';

/**
 * Individual item for Subnav component
 */

function SubnavItem(_ref) {
  let {
    active,
    componentEl: Component
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["active", "componentEl"]);

  const props = active ? {
    'aria-current': 'page'
  } : {};
  const className = ['st_subnav__link'];
  if (active) className.push('st_subnav__link--active');
  return /*#__PURE__*/React.createElement("div", {
    className: "st_subnav__item"
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: className.join(' ')
  }, props, otherProps)));
}

SubnavItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** whether this is the current page */
  active: PropTypes.bool
};
SubnavItem.defaultProps = {
  active: false,
  componentEl: 'a'
};
SubnavItem.displayName = 'Subnav.Item';

/**
Sub-navigation component for web apps with multiple sections
*/

function Subnav(_ref) {
  let {
    componentEl: Component,
    margin,
    className,
    children,
    align
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "margin", "className", "children", "align"]);

  let cssClasses = ['st_subnav'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/React.createElement(Group, {
    gap: "mlg",
    align: align,
    className: "st_subnav--links"
  }, children));
}

Subnav.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for component, if any */
  margin: marginProps,

  /** instances of `<Button tertiary />` */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,

  /**
   * how to align items horizontally. Use space-between to get some items on the right side.
   * See Storybook for examples. */
  align: PropTypes.oneOf(['start', 'end', 'space-between'])
};
Subnav.defaultProps = {
  componentEl: 'nav',
  className: null,
  margin: {
    top: 'none',
    bottom: 'sm'
  },
  align: 'start'
};
Subnav.Item = SubnavItem;

export default Subnav;
